// async function giveawayPromo() {
//     const GIVEAWAY_VARIANT_ID = 44196679942188;
//     const THRESHOLD = 1000;
//     const DISCOUNT_CODE = 'LANDONGIFT26'; 

//     async function updateGiveawayCart() {
//         try {
//             const response = await fetch(window.Shopify.routes.root + 'cart.js');
//             const cart = await response.json();
            
//             const giveawayItem = cart.items.find(item => item.variant_id === GIVEAWAY_VARIANT_ID);
//             const giveawayValue = giveawayItem ? giveawayItem.final_line_price : 0;
//             const effectiveSubtotal = (cart.total_price - giveawayValue) / 100;

//             if (effectiveSubtotal >= THRESHOLD && !giveawayItem) {
//                 console.log("Threshold met. Applying discount and adding item...");
                
//                 // 1. Apply the discount code to the session first
//                 await fetch(`/discount/${DISCOUNT_CODE}`);
                
//                 // 2. Add the item
//                 await addToCart(GIVEAWAY_VARIANT_ID);
                
//                 window.location.reload();
//             } 
//             else if (effectiveSubtotal < THRESHOLD && giveawayItem) {
//                 console.log("Below threshold. Removing giveaway item...");
//                 await removeFromCart(GIVEAWAY_VARIANT_ID);
                
//                 // Optional: Clear the discount code if subtotal drops
//                 await fetch(`/discount/CLEAR`); 
                
//                 window.location.reload();
//             }
//         } catch (error) {
//             console.error("Error managing giveaway:", error);
//         }
//     }

//     async function addToCart(id) {
//         return fetch(window.Shopify.routes.root + 'cart/add.js', {
//             method: 'POST',
//             headers: { 'Content-Type': 'application/json' },
//             body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
//         });
//     }

//     async function removeFromCart(id) {
//         return fetch(window.Shopify.routes.root + 'cart/update.js', {
//             method: 'POST',
//             headers: { 'Content-Type': 'application/json' },
//             body: JSON.stringify({ updates: { [id]: 0 } })
//         });
//     }

//     await updateGiveawayCart();
// }

// document.addEventListener('click', async (event) => {
//   const target = event.target.closest('.quantity-minus, .quantity-plus, .cart-items__remove');
  
//   if (target) {
//     if(target.getAttribute('data-tag') == "admin") {
//         console.log('Cart changed, checking giveaway status...');

//         // Small delay to allow the theme's native Ajax call to update the cart first
//         // This ensures giveawayPromo reads the correct updated subtotal
//         setTimeout(async () => {
//         const cartChanged = await giveawayPromo();

//         if (cartChanged) {
//             console.log("Cart Changed");
//             window.location.reload();
//         }
//         }, 500); 
//     }
//   }
// });

document.addEventListener('DOMContentLoaded', () => {
  const skuElement = document.querySelector('.product-sku');
  if (skuElement && skuElement.classList.contains('is-newco')) {
    const returnsBlock = document.querySelector('.pdp-returns-flex-block');
    if (returnsBlock) {
      returnsBlock.style.display = 'flex';
    }
  }
});